// extracted by mini-css-extract-plugin
export default {"flexGrow":"NavigationBar_flexGrow__9Faz9","actions":"NavigationBar_actions__8szrO"};